/**
 * @fileoverview gRPC-Web generated client stub for cloud
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var general_pb = require('./general_pb.js')

var comments_pb = require('./comments_pb.js')
const proto = {};
proto.cloud = require('./service_modification_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceModifyProjectClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceModifyProjectPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.EntityTagUpdateRequest,
 *   !proto.cloud.TagUpdateResponse>}
 */
const methodDescriptor_ServiceModifyProject_UpdateEntityTags = new grpc.web.MethodDescriptor(
  '/cloud.ServiceModifyProject/UpdateEntityTags',
  grpc.web.MethodType.UNARY,
  proto.cloud.EntityTagUpdateRequest,
  proto.cloud.TagUpdateResponse,
  /**
   * @param {!proto.cloud.EntityTagUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.TagUpdateResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.EntityTagUpdateRequest,
 *   !proto.cloud.TagUpdateResponse>}
 */
const methodInfo_ServiceModifyProject_UpdateEntityTags = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.TagUpdateResponse,
  /**
   * @param {!proto.cloud.EntityTagUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.TagUpdateResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.EntityTagUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.TagUpdateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.TagUpdateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceModifyProjectClient.prototype.updateEntityTags =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceModifyProject/UpdateEntityTags',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyProject_UpdateEntityTags,
      callback);
};


/**
 * @param {!proto.cloud.EntityTagUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.TagUpdateResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceModifyProjectPromiseClient.prototype.updateEntityTags =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceModifyProject/UpdateEntityTags',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyProject_UpdateEntityTags);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.JobTagUpdateRequest,
 *   !proto.cloud.TagUpdateResponse>}
 */
const methodDescriptor_ServiceModifyProject_UpdateJobTags = new grpc.web.MethodDescriptor(
  '/cloud.ServiceModifyProject/UpdateJobTags',
  grpc.web.MethodType.UNARY,
  proto.cloud.JobTagUpdateRequest,
  proto.cloud.TagUpdateResponse,
  /**
   * @param {!proto.cloud.JobTagUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.TagUpdateResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.JobTagUpdateRequest,
 *   !proto.cloud.TagUpdateResponse>}
 */
const methodInfo_ServiceModifyProject_UpdateJobTags = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.TagUpdateResponse,
  /**
   * @param {!proto.cloud.JobTagUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.TagUpdateResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.JobTagUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.TagUpdateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.TagUpdateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceModifyProjectClient.prototype.updateJobTags =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceModifyProject/UpdateJobTags',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyProject_UpdateJobTags,
      callback);
};


/**
 * @param {!proto.cloud.JobTagUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.TagUpdateResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceModifyProjectPromiseClient.prototype.updateJobTags =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceModifyProject/UpdateJobTags',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyProject_UpdateJobTags);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.JobNoteUpdateRequest,
 *   !proto.cloud.JobNoteUpdateResponse>}
 */
const methodDescriptor_ServiceModifyProject_UpdateJobNotes = new grpc.web.MethodDescriptor(
  '/cloud.ServiceModifyProject/UpdateJobNotes',
  grpc.web.MethodType.UNARY,
  proto.cloud.JobNoteUpdateRequest,
  proto.cloud.JobNoteUpdateResponse,
  /**
   * @param {!proto.cloud.JobNoteUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.JobNoteUpdateResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.JobNoteUpdateRequest,
 *   !proto.cloud.JobNoteUpdateResponse>}
 */
const methodInfo_ServiceModifyProject_UpdateJobNotes = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.JobNoteUpdateResponse,
  /**
   * @param {!proto.cloud.JobNoteUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.JobNoteUpdateResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.JobNoteUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.JobNoteUpdateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.JobNoteUpdateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceModifyProjectClient.prototype.updateJobNotes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceModifyProject/UpdateJobNotes',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyProject_UpdateJobNotes,
      callback);
};


/**
 * @param {!proto.cloud.JobNoteUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.JobNoteUpdateResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceModifyProjectPromiseClient.prototype.updateJobNotes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceModifyProject/UpdateJobNotes',
      request,
      metadata || {},
      methodDescriptor_ServiceModifyProject_UpdateJobNotes);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceCommentingClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceCommentingPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.AddCommentRequest,
 *   !proto.cloud.AddCommentResponse>}
 */
const methodDescriptor_ServiceCommenting_AddComment = new grpc.web.MethodDescriptor(
  '/cloud.ServiceCommenting/AddComment',
  grpc.web.MethodType.UNARY,
  proto.cloud.AddCommentRequest,
  proto.cloud.AddCommentResponse,
  /**
   * @param {!proto.cloud.AddCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AddCommentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.AddCommentRequest,
 *   !proto.cloud.AddCommentResponse>}
 */
const methodInfo_ServiceCommenting_AddComment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.AddCommentResponse,
  /**
   * @param {!proto.cloud.AddCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AddCommentResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.AddCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.AddCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.AddCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceCommentingClient.prototype.addComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceCommenting/AddComment',
      request,
      metadata || {},
      methodDescriptor_ServiceCommenting_AddComment,
      callback);
};


/**
 * @param {!proto.cloud.AddCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.AddCommentResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceCommentingPromiseClient.prototype.addComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceCommenting/AddComment',
      request,
      metadata || {},
      methodDescriptor_ServiceCommenting_AddComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.RedactCommentRequest,
 *   !proto.cloud.RedactCommentResponse>}
 */
const methodDescriptor_ServiceCommenting_RedactOwnComment = new grpc.web.MethodDescriptor(
  '/cloud.ServiceCommenting/RedactOwnComment',
  grpc.web.MethodType.UNARY,
  proto.cloud.RedactCommentRequest,
  proto.cloud.RedactCommentResponse,
  /**
   * @param {!proto.cloud.RedactCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.RedactCommentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.RedactCommentRequest,
 *   !proto.cloud.RedactCommentResponse>}
 */
const methodInfo_ServiceCommenting_RedactOwnComment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.RedactCommentResponse,
  /**
   * @param {!proto.cloud.RedactCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.RedactCommentResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.RedactCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.RedactCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.RedactCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceCommentingClient.prototype.redactOwnComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceCommenting/RedactOwnComment',
      request,
      metadata || {},
      methodDescriptor_ServiceCommenting_RedactOwnComment,
      callback);
};


/**
 * @param {!proto.cloud.RedactCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.RedactCommentResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceCommentingPromiseClient.prototype.redactOwnComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceCommenting/RedactOwnComment',
      request,
      metadata || {},
      methodDescriptor_ServiceCommenting_RedactOwnComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.DeleteCommentRequest,
 *   !proto.cloud.DeleteCommentResponse>}
 */
const methodDescriptor_ServiceCommenting_DeleteOwnComment = new grpc.web.MethodDescriptor(
  '/cloud.ServiceCommenting/DeleteOwnComment',
  grpc.web.MethodType.UNARY,
  proto.cloud.DeleteCommentRequest,
  proto.cloud.DeleteCommentResponse,
  /**
   * @param {!proto.cloud.DeleteCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeleteCommentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.DeleteCommentRequest,
 *   !proto.cloud.DeleteCommentResponse>}
 */
const methodInfo_ServiceCommenting_DeleteOwnComment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.DeleteCommentResponse,
  /**
   * @param {!proto.cloud.DeleteCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeleteCommentResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.DeleteCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.DeleteCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.DeleteCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceCommentingClient.prototype.deleteOwnComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceCommenting/DeleteOwnComment',
      request,
      metadata || {},
      methodDescriptor_ServiceCommenting_DeleteOwnComment,
      callback);
};


/**
 * @param {!proto.cloud.DeleteCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.DeleteCommentResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceCommentingPromiseClient.prototype.deleteOwnComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceCommenting/DeleteOwnComment',
      request,
      metadata || {},
      methodDescriptor_ServiceCommenting_DeleteOwnComment);
};


module.exports = proto.cloud;

